<template>
  <div class="page">
    <el-page-header @back="goBack" content="详情页面">
    </el-page-header>
    <div style="height:20px;"></div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>订单信息</span>
      </div>
      <div class="text item">
        <el-table :data="orderItems">
          <el-table-column prop="orderNo" label="子订单号" align="center" width="180">
          </el-table-column>
          <el-table-column prop="productSkuName" label="商品信息" align="center" min-width="180">
          </el-table-column>
          <el-table-column prop="productCode" label="商品编码" align="center" width="180">
          </el-table-column>
          <!-- <el-table-column align="center" prop="unitPrice" label="商品价格"> -->
          <el-table-column align="center" prop="unitBillPrice" label="商品价格">
          </el-table-column>
          <el-table-column prop="quantity" align="center" label="数量">
          </el-table-column>
          <el-table-column prop="payTotalBillAccount" align="center" label="合计">
            <!--            <template slot-scope="scope">-->
            <!--              {{ scope.row.unitPrice * scope.row.quantity }}-->
            <!--            </template>-->
          </el-table-column>
          <el-table-column align="center" label="收货信息">
            <template slot-scope="scope">
              <span style="display: inline-block;margin-right:10px;">
                {{ scope.row.receivingName }}
                {{ scope.row.receivingMobile }}
                {{ scope.row.receivingProviceName }}
                {{ scope.row.receivingCityName }}
                {{ scope.row.receivingDistrictName }}
                {{ scope.row.receivingStreetName }}
                {{ scope.row.receivingAddress }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="accountRemark" align="center" label="客户备注">
          </el-table-column>
        </el-table>
      </div>
    </el-card>
    <div style="height:20px;"></div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>采购信息</span>

      </div>
      <el-table :data="orderPurchase">
        <el-table-column prop="productSupplierName" align="center" label="采购供应商" width="180">
        </el-table-column>
        <el-table-column align="center" label="退换货" width="180">
        </el-table-column>
        <!--        <el-table-column-->
        <!--            prop=""-->
        <!--            align="center"-->
        <!--            label="数量"-->
        <!--            width="180">-->
        <!--        </el-table-column>-->
        <el-table-column prop="orderPurchaseNo" align="center" label="采购单号">
        </el-table-column>
        <el-table-column prop="purchaseQuantity" align="center" label="采购数量">
        </el-table-column>
        <!-- <el-table-column prop="purchasePrice" align="center" label="采购单价">
        </el-table-column> -->
        <el-table-column prop="creationTime" align="center" label="操作时间">
        </el-table-column>
      </el-table>
    </el-card>
    <div style="height:20px;"></div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>发货信息</span>
      </div>
      <el-table :data="orderLogistics">
        <el-table-column prop="productSupplierName" label="采购供应商" align="center" width="180">
        </el-table-column>
        <el-table-column align="center" label="发货状态">
          <template slot-scope="scope">

            <!--            <v-if='scope.' span>{{'待采购'}}</span>-->
            <!--            <span>{{'待发货'}}</span>-->
            <!--            <span>{{'待收货'}}</span>-->
            <!--            <span>{{'已收货'}}</span>-->
            {{
                scope.row.status == 1 ? '待采购' : scope.row.status == 2 ? '待发货' : scope.row.status == 3 ? '待收货' :
                  scope.row.status == 4 ? '已收货' :
                    '无法获取'
            }}
          </template>
        </el-table-column>
        <el-table-column prop="shipmentQuantity" align="center" label="发货数量">
        </el-table-column>
        <el-table-column align="center" label="待发货数量">
          <template slot-scope="scope">
            {{ scope.row.orderQuantity - scope.row.purchasedQuantity }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="creationTime" label="操作时间">
        </el-table-column>
        <!--        <el-table-column-->
        <!--            width="200"-->
        <!--            align="center"-->
        <!--            prop="address"-->
        <!--            label="操作">-->
        <!--          <template slot-scope="scope">-->
        <!--            <el-button size="mini" v-for="(item, index) in buttonList_table" :key="index" :type="item.buttonType"-->
        <!--                       @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}-->
        <!--            </el-button>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
      </el-table>
    </el-card>
    <div style="height:20px;"></div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>订单备注</span>
      </div>
      <div v-loading="noteLoading">
        <el-card style="margin-bottom:20px;">
          <el-table
              :data="remarkList"
              border
              style="width: 100%">
            <el-table-column
                prop="orderId"
                label="订单Id">
            </el-table-column>
            <el-table-column
                label="备注内容">
              <template slot-scope="scoped">
                <h4>{{scoped.row.note}}</h4>
                <div>
                  <div style="display: inline-block;margin-right:5px;" v-for="(item,index) in scoped.row.pics">
                    <img :src="item" style="width: 100px;height:100px;"/>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="creationUser"
                label="提交人">
            </el-table-column>
            <el-table-column
                prop="creationTime"
                label="提价时间">
            </el-table-column>
          </el-table>
        </el-card>
      </div>
    </el-card>
    <div style="height:20px;"></div>
    <el-dialog title="发货记录" :visible.sync="checkDialog" :show-close="false" width="60%">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="warehouseName" label="发货仓库" align="center" width="180">
        </el-table-column>
        <el-table-column prop="shipmentQuantity" align="center" label="总发货数量" width="180">
        </el-table-column>
        <el-table-column prop="address" align="center" label="物流公司">
        </el-table-column>
        <el-table-column prop="address" align="center" label="物流单号">
        </el-table-column>
        <el-table-column prop="shipmentQuantity" align="center" label="此单发货数量">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="checkDialog = false">取 消</el-button>
        <el-button type="primary" @click="checkDialog = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="更改物流信息" :visible.sync="edit" :show-close="false" width="30%">
      <el-form>
        <el-form-item label="采购供应商">
          {{ editLogis.SupplierName }}
        </el-form-item>
        <el-form-item label="物流公司">
          <el-select v-model="value" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物流单号">
          <el-input v-model="editLogis.LogisticsCompanyCode" style="width:220px;" placeholder="请输入物流单号"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="edit = false">取 消</el-button>
        <el-button type="primary" @click="editLogistics">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getButtonList } from "../../../promissionRouter";
import toolbar from "../../../components/Toolbar";
import {
  OrderPurchaseGet,
  OrderLogisticGet,
  OrderLogisticUpdate,
  OrderLogisticEdit,
  LogisticsCompanyServiceGetAll,
  OrderWarehouseGetAll, OrderGetOrderNoteList
} from "../../../api/api";
import Supplier from "../../Sale/Supplier";

export default {
  components: { toolbar },
  data() {
    return {
      noteLoading: false,
      orderId:null,
      remarkList: [],
      searchData: {
        id: null,
      },
      singleLogistic: {
        LogisticsCompanyName: '河南幫',
        LogisticsCompanyCode: 'adsadfasdfasfasf'
      },
      LogisTime: [],
      editLogis: {
        LogisticsCompanyCode: '',
        SupplierName: '',
      },
      buttonList_table: [],
      checkDialog: false,
      edit: false,
      options: [{
        value: '1',
        label: '黄金糕1'
      }, {
        value: '2',
        label: '黄金糕2'
      }],
      value: '2',
      orderItems: [],
      orderPurchase: [],
      orderLogistics: [],
      tableData: []
    };
  },
  created() {
    if (this.$route.query.id) {
      this.searchData.id = this.$route.query.id;
      this.orderId = this.$route.query.id;
    }
    this.getTableData()
    this.getAllCompany();
    this.getRemarkList()
  },
  methods: {
    async getRemarkList() {
      this.noteLoading = true;
      let res = await OrderGetOrderNoteList({orderId:this.orderId});
      if (res.data.success) {
        this.noteLoading = false;
        if (res.data.result) {
          res.data.result.forEach((item, index)=>{
            if (item.images) {
              item.pics = item.images.split(',')
            }
          })
        }
        this.remarkList = res.data.result
      }else{
        this.noteLoading = false;
        this.$message.error(res.data.error.message);
      }
      console.log('订单备注', res);
    },
    async getAllCompany() {
      let res = await LogisticsCompanyServiceGetAll();
      console.log('物流公司list', res);
    },
    async getTableData() {
      let res = await OrderPurchaseGet(this.searchData);
      console.log('待采购详情', res);
      if (res.data.success) {
        // this.OrderItems = res.data.result.OrderItems;
        let orderItems = res.data.result.orderItems && res.data.result.orderItems[0];
        orderItems.orderNo = res.data.result.orderNo;
        orderItems.purchaseTotal = res.data.result.purchaseTotal;
        orderItems.payTotalAccount = res.data.result.payTotalAccount;
        orderItems.purchasedQuantity = res.data.result.purchasedQuantity;
        orderItems.purchasePrice = res.data.result.purchasePrice;
        orderItems.payTotalBillAccount = res.data.result.payTotalBillAccount;
        // orderItems.productCode = res.data.result.orderItems[0].productCode;
        
        let productSkuName = res.data.result.orderItems[0].productSkuName;
        // console.log('productSkuName', productSkuName);
        let status = res.data.result.status;
        let orderQuantity = res.data.result.orderQuantity;
        let purchasedQuantity = res.data.result.purchasedQuantity;

        orderItems.receivingName = res.data.result.receivingName;
        orderItems.receivingMobile = res.data.result.receivingMobile;
        orderItems.receivingProviceName = res.data.result.receivingProviceName;
        orderItems.receivingCityName = res.data.result.receivingCityName;
        orderItems.receivingDistrictName = res.data.result.receivingDistrictName;
        orderItems.receivingStreetName = res.data.result.receivingStreetName;
        orderItems.receivingAddress = res.data.result.receivingAddress;
        orderItems.accountRemark = res.data.result.accountRemark;
        // receivingName  receivingMobile  receivingProviceName  receivingCityName
        // receivingDistrictName  receivingStreetName  accountRemark
        this.orderItems = [orderItems];
        // console.log('orderitems', this.orderItems);


        // let productSkuName = res.data.result.orderItems && res.data.result.orderItems[0] &&
        //     res.data.result.orderItems[0].productSkuName || '';
        let orderPurchases = res.data.result.orderPurchases && res.data.result.orderPurchases || [];

        if (orderPurchases.length > 0) {
          orderPurchases.forEach(item => {
            item.productSkuName = productSkuName
          })
        }
        this.orderPurchase = orderPurchases;
        console.log('orderPurchases', this.orderPurchase);
        // let orderPurchases = res.data.result.orderPurchases && res.data.result.orderPurchases[0] || {};
        // orderPurchases.productSkuName = res.data.result.orderItems && res.data.result.orderItems[0] &&
        //     res.data.result.orderItems[0].productSkuName || '';

        // let params = {};
        // params.orderPurchases = orderPurchases;
        // params.proInfo = productSkuName;
        // this.orderPurchase = [orderPurchases];

        // this.OrderPurchase = res.data.result.orderPurchase;
        let orderLogistics = res.data.result.orderLogistics && res.data.result.orderLogistics || [];
        console.log('orderLogistics', orderLogistics);

        if (orderLogistics.length > 0) {
          orderLogistics.forEach(item => {
            item.productSkuName = productSkuName;
            item.status = status;
            item.orderQuantity = orderQuantity;
            item.purchasedQuantity = purchasedQuantity;
          })
        }
        // orderLogistics.productSkuName = res.data.result.orderItems && res.data.result.orderItems[0] &&
        //  res.data.result.orderItems[0].productSkuName || '';
        // orderLogistics.productSkuName = res.data.result.orderItems && res.data.result.orderItems[0] &&
        //     res.data.result.orderItems[0].productSkuName || '';
        //
        // this.orderLogistics = [orderLogistics];
        this.orderLogistics = orderLogistics;

      } else {
        this.$message.error(res.data.msg || '获取详情失败, 请重试');
      }
    },
    async editLogistics(button, index, row) {
      return;
      let res = await OrderLogisticEdit({ id: row.id });
      console.log('物流修改', res);
      if (res.data.success) {
        this.edit = false;
      } else {
        this.$message.error(res.data.msg || '更新失败, 请重试');
      }
    },
    async checkLogistics(button, index, row) {
      this.checkDialog = true;
      console.log('查看物流rowrowrowrowrow', row)
      let res = await OrderWarehouseGetAll({ orderId: row.orderId, orderPurchaseId: row.orderPurchaseId });
      console.log('查看物流', res);
      if (res.data.success) {
        this.tableData = res.data.result.items;
      } else {
        this.$message.error(res.data.msg || '获取失败, 请重试');
      }
    },
    async updateLogistics() {
      console.log('更改物流');
      this.edit = true;
      let res = await OrderLogisticGet();
      if (res.data.success) {
        this.value = String(res.data.logisticsCompanyId);
        this.editLogis.LogisticsCompanyCode = res.data.logisticsCompanyCode;
        this.editLogis.SupplierName = res.data.SupplierName;
      } else {
        this.$message.error(res.data.msg || '获取失败, 请重试');
      }
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    // jumpToProduct(SpuId){
    //   window.open(`/Product/ComManagement/AddEditSpu?id=${SpuId}`);
    // },
    goBack() {
      this.$router.go(-1);
    },
    // handleBack() {
    //   this.$router.back();
    // },
    // callFunction(item) {
    //   this[item.Func]();
    // },
  },
  mounted() {
    let that = this;
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    var buttonList = getButtonList(this.$route.path, routers);
    const tableList = buttonList.filter((item) => {
      return item.buttonShow === 20;
    });
    this.buttonList_table = tableList;
  },
};
</script>

<style scoped>
.qgg-table {
  border-collapse: collapse;
  width: 100%;
  border: 1px solid #c6c6c6 !important;
  margin-bottom: 20px;
}

.qgg-table td {
  padding: 10px;
}

.qgg-table th {
  padding: 10px;
}

/*.qgg-table th{*/
/*  border-collapse: collapse;*/
/*  border-right:1px solid #c6c6c6 !important;*/
/*  border-bottom:1px solid #c6c6c6 !important;*/
/*  background-color:#ddeeff !important;*/
/*  padding:5px 9px;*/
/*  font-size:14px;*/
/*  font-weight:normal;*/
/*  text-align:center;*/
/*}*/
/*.qgg-table td{*/
/*  border-collapse: collapse;*/
/*  border-right:1px solid #c6c6c6 !important;*/
/*  border-bottom:1px solid #c6c6c6 !important;*/
/*  padding:5px 9px;*/
/*  font-size:12px;*/
/*  font-weight:normal;*/
/*  text-align:center;*/
/*  word-break: break-all;*/
/*}*/
/*.qgg-table tr:nth-child(odd){*/
/*  background-color:#fff !important;*/
/*}*/
/*.qgg-table tr:nth-child(even){*/
/*  background-color: #f8f8f8 !important;*/
/*}*/
</style>
